import {UcoastEl} from "@/scripts/core/UcoastEl";
import {
	currentTargetRequired,
	getAttributeOrThrow,
	getSectionHTMLForResource,
	qsaRequired,
	qsRequired,
} from '@/scripts/core/global'

type ReviewListItem = {
	id: string
	element: HTMLElement
	rating: number
	createdAt: number
}

export class JunipPrimaryContainer extends UcoastEl {
	static htmlSelector = 'junip-primary-container';
	filterOptions: NodeListOf<HTMLButtonElement>
	filterLabel: HTMLElement
	loadMoreButton: HTMLButtonElement
	reviews?: ReviewListItem[]
	reviewsContainer: HTMLElement

	constructor() {
		super();
		this.filterOptions = qsaRequired('[junip-filter-option]', this)
		this.loadMoreButton = qsRequired('[junip-load-more]', this)
		this.filterLabel = qsRequired('[data-filter-text]', this)
		this.reviewsContainer = qsRequired('[data-reviews-container]', this)
		this.filterOptions.forEach((option) => {
			option.addEventListener('click', this.handleFilterOptionClick.bind(this))
		})
		this.loadMoreButton.addEventListener('click', this.handleLoadMoreClick.bind(this))
	}
	handleFilterOptionClick(e: Event) {
		const target = currentTargetRequired(e)
		const text = target.textContent
		this.filterLabel.textContent = text
		const currentFilter = this.getFilterValue()
		const value = getAttributeOrThrow('junip-filter-option', target)
		if (currentFilter === value) {
			return
		}
		this.renderFilteredReviews(value)
	}

	getFilterValue() {
		return getAttributeOrThrow('data-filter', this)
	}

	async renderFilteredReviews(value: string) {
		this.setAttribute('data-filter', value)
		if (!this.reviews) {
			await this.loadReviews()
		}
		const currentCount = this.getCurrentReviewsLoadedCount();
		switch(value) {
			case 'newest':
				this.filterByNewest()
				break;
			case 'oldest':
				this.filterByOldest()
				break;
			case 'highest_rating':
				this.filterByHighestRating()
				break;
			case 'lowest_rating':
				this.filterByLowestRating()
				break;
			default:
			// code block
		}
		this.reviewsContainer.innerHTML = ''
		this.reviews?.forEach((review, index) => {
			if (index < currentCount) {
				this.reviewsContainer.appendChild(review.element)
			}
		})
		console.log('this.reviews.length', this?.reviews?.length)
		console.log('reviews at 1 star')
		console.log(this?.reviews?.filter((review) => review.rating === 1))
	}

	getCurrentReviewsLoadedCount() {
		return parseInt(getAttributeOrThrow('data-reviews-loaded', this))
	}

	setCurrentReviewsLoadedCount(count: number) {
		this.setAttribute('data-reviews-loaded', count.toString())
	}

	getProductUrl() {
		return getAttributeOrThrow('data-product-url', this)
	}

	async loadReviews() {
		const html = await getSectionHTMLForResource(this.getProductUrl(), 'junip-container-complete')
		if (!html) throw new Error('No reviews found')
		const parser = new DOMParser()
		const doc = parser.parseFromString(html, 'text/html')
		const reviewDOMElements = qsaRequired('[data-review-id]', doc)
		this.reviews = Array.from(reviewDOMElements).map(this.createReviewListFromDOMElement)
	}

	handleLoadMoreClick(_: Event) {
		void this.loadMore()
	}

	filterByNewest() {
		this.reviews = this.reviews?.sort((a, b) => b.createdAt - a.createdAt)
	}

	filterByOldest() {
		this.reviews = this.reviews?.sort((a, b) => a.createdAt - b.createdAt)
	}

	filterByHighestRating() {
		this.reviews = this.reviews?.sort((a, b) => b.rating - a.rating)
	}

	filterByLowestRating() {
		this.reviews = this.reviews?.sort((a, b) => a.rating - b.rating)
	}

	async loadMore() {
		if (!this.reviews) {
			await this.loadReviews()
		}
		const countToLoad = 10;
		const currentCount = this.getCurrentReviewsLoadedCount()
		const newCount = currentCount + countToLoad
		this.setCurrentReviewsLoadedCount(newCount)

		this.reviews?.forEach((review, index) => {
			if (index >= currentCount && index <= newCount) {
				this.reviewsContainer.appendChild(review.element)
			}
		})
	}

	createReviewListFromDOMElement(domElement: HTMLElement): ReviewListItem {
		const id = getAttributeOrThrow('data-review-id', domElement)
		const rating = parseInt(getAttributeOrThrow('data-review-rating', domElement))
		const createdAt = parseInt(getAttributeOrThrow('data-review-created-at', domElement))
		return {
			id,
			element: domElement,
			rating,
			createdAt
		}
	}
}

export class JunipContainerText extends UcoastEl {
	static htmlSelector = 'junip-container-text';

	constructor() {
		super();
	}
}

export class JunipContainerMedia extends UcoastEl {
	static htmlSelector = 'junip-container-media';

	constructor() {
		super();
	}
}

export class JunipReviewForm extends UcoastEl {
	static htmlSelector = 'junip-review-form';

	constructor() {
		super();
	}
}


export class JunipItemImage extends UcoastEl {
	static htmlSelector = 'junip-item-image'

	constructor() {
		super()

		console.log('i have mounted?????')
	}
}